import React, { useState } from 'react';
import EditorialModule from './EditorialModule';
import { EditorialProject } from '../../../../types/EditorialProject.types';
import { MOCK_EDITORIAL_PROJECTS } from '../../../../mocks/EditorialProjects.mocks';
import './EditorialModule.css';

// Módulo Editorial: catálogo de proyectos + las 4 fases del flujo (evaluación,
// contratación, producción, cierre). Todo maqueta/placeholder por ahora — sin
// ningún API real detrás, igual que el resto de módulos que aún no se han
// conectado al backend.
export const EditorialView = () => {
  const [projects, setProjects] = useState<EditorialProject[]>(MOCK_EDITORIAL_PROJECTS);
  return <EditorialModule projects={projects} setProjects={setProjects} />;
};
